import React from 'react';
import Header from '../components/Header';
import CardPlus from '../components/CardPlus';

const RED = () => {
  return (
    <div>
      <Header/>
      <CardPlus/>
    </div>
  );
};

export default RED;